import React,{useState,useEffect} from 'react';
import {CheckCircleOutlined } from 'components/shared/AntIcons';

const ConsentSuccess:React.FC=()=>{
    return(
        <div className='bg-light h-100 d-flex align-items-center justify-content-center'>
            <div className='container mx-auto w-50 text-center'>
                <CheckCircleOutlined className='text-success fs-50'/>
                <h3 className='mt-3'>Consent Submitted Successfully</h3>
                <p className='text-muted mt-3'>The QEEG consent form has been signed and recorded.</p>
                <p className='text-muted'>A copy of the signed consent has been saved to the patient&apos;s records.</p>
                <div className='mt-4'>

                </div>
            </div>
        </div>
    )
}

export default ConsentSuccess;